/** "Iron Logic" protocol operations: base event types */
export enum IronLogicOperationEnum {
  /** From converter: initial "handshake" operation */
  POWER_ON = 'power_on',
  /** From converter: check card access */
  CHECK_ACCESS = 'check_access',
  /** From converter: test connection to FRM */
  PING = 'ping',
  /** From converter: events */
  EVENTS = 'events',
  /** From server: initialize/deinitialize converter connection */
  SET_ACTIVE = 'set_active',
  /** From server: open converter's door */
  OPEN_DOOR = 'open_door',
  /** From server: set converter's mode */
  SET_MODE = 'set_mode',
  /** From server: set converter's time zone */
  SET_TIMEZONE = 'set_timezone',
  /** From server: set parameters for door */
  SET_DOOR_PARAMS = 'set_door_params',
  /** From server: add access keys to converter */
  ADD_CARDS = 'add_cards',
  /** From server: delete access keys from converter */
  DEL_CARDS = 'del_cards',
  /** From server: delete all access keys from converter */
  CLEAR_CARDS = 'clear_cards',
  /** From server: read cards by converter */
  READ_CARDS = 'read_cards',
  /** Is not a command! Crutch: to distinguish the synchronization method from the usual method of adding a card */
  ADD_CARDS_CONCRETE = 'add_cards_concrete',
}
